module.exports = __webpack_public_path__ + "img/api-spec-first-thumbnail-arrow.49b81ee2.jpg";